var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44.0416,
    height: 44.0416,
    rx: 22.0208,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8893 25.5417C17.6819 25.3342 17.6819 24.9978 17.8893 24.7904L24.4954 18.1843L19.0163 18.1843C18.7229 18.1843 18.485 17.9464 18.485 17.653C18.485 17.3596 18.7229 17.1218 19.0163 17.1218L25.778 17.1218C26.0714 17.1218 26.3092 17.3596 26.3092 17.653L26.3092 24.4147C26.3092 24.7081 26.0714 24.946 25.778 24.946C25.4846 24.946 25.2467 24.7081 25.2467 24.4147V18.9356L18.6406 25.5417C18.4332 25.7491 18.0968 25.7491 17.8893 25.5417Z",
    fill: "#1D83F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnroll);
export default __webpack_public_path__ + "static/media/enroll.b8176ce146ba98d0f7086565e5622ea8.svg";
export { ForwardRef as ReactComponent };